import { cva } from '@/styled-system/css';

export const toggleCardHeaderRecipe = cva({
  base: {
    'marginBlockEnd': 'loose',

    '& > .c11n_heading': {
      textStyle: 'heading-xs',
    },
  },
  variants: {
    divider: {
      true: {
        paddingBlockEnd: 'default',
        borderBlockEndWidth: 'default',
        borderBlockEndStyle: 'solid',
        borderBlockEndColor: 'ToggleCard.Header.border',
      },
      false: {},
    },
  },
});
